//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//import publicRoute from "./component/publicRoute"
import * as auth from "@/utils/auth";
export default {
  //extends: commonload,
  name: "portLoad",
  data() {
    return {
      url: "api/api/getApplyJobInfo",
      record: {}, //
      isMobile: false,
    };
  },
  mounted() {
    this.isMobile = this.$isMobile();
  },
  methods: {
    goBack: function () {
      this.$router.go(-1);
    },
    async doLoadRecord() {
      let uuid = this.$route.query.uuid;
      let oQuery = {
        uuid: uuid,
      };
      await this.axios.post(this.url, oQuery).then(({ data }) => {
        if (data.code == "1") {
          this.record = data.data.record;
        }
      });
    },
    openApply() {
      let token = auth.getToken();
      if (this.isNotNullOrEmpty(token)) {
        let uuid = this.$route.query.uuid;
        this.checkJobInfo(uuid);
      } else {
        this.$router.push({
          path: "/portal/login",
          query: {},
        });
      }
    },
    async checkJobInfo(uuid) {
      //验证该岗位是否未发布
      let checkUrl = "api/api/portalLogin/checkJobInfo";
      let params = {
        uuid: uuid,
      };
      await this.axios
        .post(checkUrl, params)
        .then(({ data }) => {
          if (data.code == "1") {
            let msg = data.data.msg;
            if (this.isNotNullOrEmpty(msg)) {
              this.$msgDailog.showMsgBox({
                title: msg,
              });
              return;
            }
            this.$router.push({
              path: "/portal/submitResume",
              query: {
                RCid: this.$route.query.RCid,
                uuid: uuid,
              },
            });
          }
        })
        .catch((error) => console.log(error));
    },
  },
  created() {
    this.doLoadRecord();
  },
};



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/portal/portLoad.vue